import { useState } from 'react'
import { ScrollArea } from '../../../../../components/ui/scroll-area'
import { GripIcon, PauseIcon, PlayIcon, Timer, XIcon } from 'lucide-react'
import { AnimatePresence, motion } from 'framer-motion'
import { useTimer } from '../../../../../context/TimerContext'
import { formatTime } from '../../../../../lib/time'
import { Trans } from '@lingui/react/macro'

type Props = {
    setactive_tab?: (tab:string) => void
    active_tab?: string
}

const Sidebar = ({setactive_tab, active_tab}:Props) => {
    const [is_open, setis_open] = useState(false);
    const { elapsedTime, setIsRunning, isRunning } = useTimer()

    const variants = {
        initial: {
            x: '100%',
            opacity: 0,
            width: 0
        },
        animate: {
            x: 0,
            opacity: 1,
            width: 'auto',
            transition: {
                delayChildren: 0,
                staggerChildren: 0.1
            }

        },
        exit: {
            x: '100%',
            opacity: 0,
            width: 0
        }
    }

    const item = {
        initial: { x: 10, opacity: 0 },
        animate: {
            x: 0,
            opacity: 1
        }
    }

  return (
    <>
    <div className='hidden sm:block sticky h-[calc(100dvh-64px)] top-16 border-r border-r-neutral-200 w-[200px]'>
      <ScrollArea className='h-full'>
        <section className='flex flex-col gap-2'>
          <div className='flex flex-col w-full'>
            <button onClick={()=>{setactive_tab && setactive_tab('customer')}} className={`${active_tab==='customer' ? 'bg-emerald-50 text-primary border-r-2 border-r-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Klant</Trans></button>
            <button onClick={()=>{setactive_tab && setactive_tab('technical-unit')}} className={`${active_tab==='technical-unit' ? 'bg-emerald-50 text-primary border-r-2 border-r-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Technische eenheid</Trans></button>
            <button onClick={()=>{setactive_tab && setactive_tab('spare-parts')}} className={`${active_tab==='spare-parts' ? 'bg-emerald-50 text-primary border-r-2 border-r-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Wisselstukken</Trans></button>
            <button onClick={()=>{setactive_tab && setactive_tab('optional-data')}} className={`${active_tab==='optional-data' ? 'bg-emerald-50 text-primary border-r-2 border-r-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Optionele gegevens</Trans></button>
            <button onClick={()=>{setactive_tab && setactive_tab('description')}} className={`${active_tab==='description' ? 'bg-emerald-50 text-primary border-r-2 border-r-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Beschrijving</Trans></button>
            {/* <button onClick={()=>{setactive_tab && setactive_tab('checklist')}} className={`${active_tab==='checklist' ? 'bg-emerald-50 text-primary border-r-2 border-r-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}>Checklijst</button> */}
            <button onClick={()=>{setactive_tab && setactive_tab('end-intervention')}} className={`${active_tab==='end-intervention' ? 'bg-emerald-50 text-primary border-r-2 border-r-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Eind interventie</Trans></button>
            <button onClick={()=>{setactive_tab && setactive_tab('history')}} className={`${active_tab==='history' ? 'bg-emerald-50 text-primary border-r-2 border-r-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Historiek</Trans></button>
            
            <div className='flex items-center justify-center gap-2 px-2 py-1 m-2 border rounded-full'>
              {isRunning 
              ? <button onClick={()=>{setIsRunning(false)}}><PauseIcon className='w-4 h-4 text-orange-500'/></button>
              : <button onClick={()=>{setIsRunning(true)}}><PlayIcon className='w-4 h-4 text-green-500'/></button>
              }
              
              <p className='py-2 font-medium text-center'>{formatTime(elapsedTime)}</p>
            </div>
          </div>
        </section>
      </ScrollArea>
    </div>

    <div className='fixed right-0 z-10 flex flex-col items-end justify-end gap-2 p-2 sm:hidden bottom-4'>
        
        
        <ScrollArea className={`${!is_open && 'hidden'}`}>
          <AnimatePresence>
          {is_open &&
          <motion.div variants={variants} exit='exit' initial='initial' animate='animate' className='flex flex-col bg-white border-l'>
              <motion.button onClick={()=>{setis_open(false); setactive_tab && setactive_tab('customer')}} variants={item} className={`${active_tab==='customer' ? 'bg-emerald-50 text-primary border-l-2 border-l-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-y`}><Trans>Klant</Trans></motion.button>
              <motion.button onClick={()=>{setis_open(false); setactive_tab && setactive_tab('technical-unit')}} variants={item} className={`${active_tab==='technical-unit' ? 'bg-emerald-50 text-primary border-l-2 border-l-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Technische eenheid</Trans></motion.button>
              <motion.button onClick={()=>{setis_open(false); setactive_tab && setactive_tab('spare-parts')}} variants={item} className={`${active_tab==='spare-parts' ? 'bg-emerald-50 text-primary border-l-2 border-l-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Wisselstukken</Trans></motion.button>
              <motion.button onClick={()=>{setis_open(false); setactive_tab && setactive_tab('optional-data')}} variants={item} className={`${active_tab==='optional-data' ? 'bg-emerald-50 text-primary border-l-2 border-l-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Optionele gegevens</Trans></motion.button>
              <motion.button onClick={()=>{setis_open(false); setactive_tab && setactive_tab('description')}} variants={item} className={`${active_tab==='description' ? 'bg-emerald-50 text-primary border-l-2 border-l-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Beschrijving</Trans></motion.button>
              {/* <motion.button onClick={()=>{setis_open(false); setactive_tab && setactive_tab('checklist')}} variants={item} className={`${active_tab==='checklist' ? 'bg-emerald-50 text-primary border-l-2 border-l-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}>Checklijst</motion.button> */}
              <motion.button onClick={()=>{setis_open(false); setactive_tab && setactive_tab('end-intervention')}} variants={item} className={`${active_tab==='end-intervention' ? 'bg-emerald-50 text-primary border-l-2 border-l-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Eind interventie</Trans></motion.button>
              <motion.button onClick={()=>{setis_open(false); setactive_tab && setactive_tab('history')}} variants={item} className={`${active_tab==='history' ? 'bg-emerald-50 text-primary border-l-2 border-l-primary' : 'bg-transparent'} text-left p-4 text-sm font-medium whitespace-nowrap border-b`}><Trans>Historiek</Trans></motion.button>
              <motion.p variants={item} className='py-2 font-medium text-center border-b'>{formatTime(elapsedTime)}</motion.p>
          </motion.div>
          }
          </AnimatePresence>
        </ScrollArea>
        
        <button onClick={()=>{setis_open(!is_open)}} className='w-12 h-12 min-h-[40px] rounded-full border flex items-center justify-center bg-white shadow-lg'>{!is_open ? <GripIcon className='w-5 h-5'/> : <XIcon className='w-5 h-5'/>}</button>

    </div>
    </>
  )
}

export default Sidebar